import { defineMessages } from 'react-intl';

export default defineMessages({
  passwordLeakedXML: {
    id: 'signup.form.password.leaked.xml',
    defaultMessage:
      'This password has appeared in an external data breach. To continue, enter another password. <password-leaked-link>Learn more</password-leaked-link>',
  },
});
